<template>
    <div class="basic_wrap">
        <div class="red_top_bg">
            <div class="back_left" @click="$router.back()"></div>
            <div class="big_tit">{{$t('lixibao.record')}}</div>
        </div>
        <!-- <div class="detail_box">
			<van-empty :description="$t('item.noData')" v-if="listShow" />
            <div class="item" v-for="item in data">
                <div class="de_wrap">
                    <p class="tit">{{item.addtime}}</p>
                    <p class="time">{{item.title}}</p>
                </div>
                <div class="price" :class="item.status !='1'?'':'del'" v-html="item.status !='1'?item.money :item.money"></div>
            </div>
        </div> -->
        <div class="items_cust item_margin">
            <div v-for="i in data" :key="i.id" class="item">
                <div class="item_div1" @click="$router.push('/item/'+i.id)">
                    <p>
                        {{i.title}}
                    </p>
                </div>
                <div class="item_div2" @click="$router.push('/item/'+i.id)">
                    <div class="item_rate">
                        <p>{{i.num}}</p>
                        <p>{{$t('lixibao.moneyMark3')}}</p>
                    </div>
                    <div class="item_rate">
                        <p>{{i.bili}}%</p>
                        <p>{{$t('utils.dailyIncome')}}</p>
                    </div>
                    <div class="item_day">
                        <p>{{i.day}}{{$t('utils.day')}}</p>
                        <p>{{$t('utils.cycle')}}</p>
                    </div>
                    <div class="item_min">
                        <p>{{i.yuji_num}}</p>
                        <p>{{$t('lixibao.yujimoney')}}</p>
                    </div>
                </div>
                <div class="item_div4">
                    <div class="item_progress">
                        {{$t('lixibao.kaishi')}}{{i.addtime}}
                    </div>
                    <div class="item_btn">
                        {{$t('lixibao.jieshu')}}{{i.endtime}}
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import Vue from 'vue';
    import Fetch from '../../utils/fetch'
    import {
        DropdownMenu,
        DropdownItem
    } from 'vant';

    import { Empty } from 'vant';

    Vue.use(Empty);
    Vue.use(DropdownMenu).use(DropdownItem);

    export default {
        name: "rechargeRecord",
        data() {
            return {
				lang:this.$i18n.locale||"zh_cn",
                data: [],
                list: {},
                account: 0,
                option: [],
                listShow:false,
                funds: 0,
                userName:''
            };
        },
        created() {
            this.$parent.footer('user', false);
        },
        mounted() {
            Fetch('/index/getlixibaolog',{
                reason_id: 1
            }).then(r => {
                this.option.push({
                    text: this.$t('moneybag.types'),
                    value: 0
                })
                
                this.showError(r.data.length);
                this.data = r.data;
                //this.funds = r.data.money;
                //this.userName = r.data.username;
            })
        },
        methods: {
            // chooseType(val) {
            //     Fetch('/user/getlixibaolog',{
            //         reason_id: val
            //     }).then(r=>{
            //         this.data = r.data.list;
            //         this.showError(r.data.list.length);
            //     })
            // },
            showError(len){
                len == 0 ? this.listShow = true : this.listShow = false
            }
        }
    };
</script>

<style lang="less" scoped>
    .red_top_bg {
        height: 45px;
        background-color: #2a1164;
        position: fixed;
    	//background-position: center;
    	//background-repeat: no-repeat;
    	//background-size: 100% 100%;
    }
    .user_yw{
    	text-align: center;
    	position: absolute;
    	top: 74px;
    	background: #1f0b4f;
    	left: 15px;
    	right: 15px;
    	border-radius: 5px;
    	padding: 15px;
    	box-shadow:  2px 2px 5px rgba(115, 115, 115, 0.35);
    	p:nth-child(1){
    		font-size: 12px;
    		color: #999999;
    		margin-bottom: 10px;
    	}
    	p:nth-child(2){
    		font-size: 24px;
    		color: #ff5551;
    		font-weight: bold;
    	}
    }
    .user_zrzc{
    	text-align: center;
    	display: flex;
    	justify-content: space-between;
    	text-align: center;
    	margin-top: 17px;
    	span{
    		width: 135px;
    		
    		color: #FFFFFF;
    		margin: 0px 12px;
    		padding: 10px;
    		font-size: 12px;
    		line-height: 15px;
    		color: #fff;
    		border-radius: 5px;
    	}
    	
    	span:nth-child(1) {
    		background: #ff5451;
    	}
    	
    	span:nth-child(2) {
    		background: #04c382;
    	}
    }
    
    .detail_box {
        background: #311573;
        margin-top: 45px;
        .item {
            display: flex;
            align-items: center;
            justify-content: space-between;
            padding: 12px 15px;
            //border-bottom: 1px solid #ffffff;
    
            .de_wrap {
                flex: 2;
    
                .tit {
                    font-size: 12px;
                    color: #ffffff;
                    line-height: 18px;
                    font-weight: bold;
                }
    
                .time {
                    font-size: 12px;
                    color: #999999;
                    line-height: 18px;
                }
            }
    
            .price {
                flex: 1;
                font-size: 12px;
                line-height: 28px;
                font-weight: bold;
                text-align: right;
                color: #e82637;
                white-space: nowrap;
                &.del {
                    color: #3FAF3E;
                }
            }
        }
    }
    .items_cust {
        margin-top:50px;
		.item {
			margin-bottom: 10px;
			border-radius: 10px;
			overflow: hidden;
			background-color: #3b1b81;
			border-radius: 4px;
			//border: 1px solid #2e116d;
			//box-shadow: 2px 2px 5px rgba(115, 115, 115, 0.35);

			// div{
			// 	margin: 5px 0;
			// }
			.item_div1 {
				display: flex;
				height: 40px;
				line-height: 40px;
				align-items: center;
				//border-bottom: 1px solid #2e116d;
				padding: 4px 10px;
				background-color: #1b0350;

				p {
					// width: 90%;
					//font-weight: bold;
					overflow: hidden;
					//text-overflow: ellipsis;
					//white-space: nowrap;
					font-size: 15px;
					color: #ffffff;
				}

				.icon {
					width: 32px;
					height: 32px;
					margin-right: 8px;
				}
			}

			.item_div2 {
				display: flex;
				justify-content: space-between;
				text-align: center;
				padding: 12px 0;
				font-size: 14px;
                border-bottom: solid 1px #4c289b;
				div {
					width: 33.33%;

					p {
						padding: 5px 0;
					}
				}

				.item_rate {
					p:nth-child(1) {
						font-weight: bold;
						color: #FFffff;
						font-size: 15px;

					}

					p:nth-child(2) {
						color: #999;
						font-size: 12px;
					}
				}

				.item_day {
					p:nth-child(1) {
						color: #FFffff;
						font-weight: bold;
						font-size: 15px;
					}

					p:nth-child(2) {
						color: #999;
						font-size: 12px;
					}
				}

				.item_min {
					p:nth-child(1) {
						color: #FFffff;
						font-weight: bold;
						font-size: 15px;

					}

					p:nth-child(2) {
						color: #999;
						font-size: 12px;
					}
				}
			}

			.item_div3 {
				color: #999;
				padding: 0 12px;
			}

			.item_div4 {
				padding: 10px 12px;
				display: flex;
				align-items: center;
				justify-content: space-between;
                color: #eeeeee;

				
			}
		}
	}
</style>
